import { HTMLAttributes, PropsWithChildren } from 'react'
import Styles from './WrapperCard.module.scss'
import { filterDOMProps } from '@react-aria/utils'

interface WrapperCardProps extends HTMLAttributes<HTMLDivElement> {
  padding?: number
  gap?: number
  backgroundColor?: string
}

export const WrapperCard = ({
  children,
  padding = 20,
  gap = 20,
  backgroundColor,
  ...props
}: PropsWithChildren<WrapperCardProps>) => {
  return (
    <div
      className={Styles.wrapper}
      style={{ padding, gap, backgroundColor }}
      {...filterDOMProps(props, { labelable: true })}
    >
      {children}
    </div>
  )
}
